import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-progress-bar',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss']
})
export class ProgressBarComponent {
  @Input() progress = 0;
  @Input() errored: boolean = false;
  @Input() barColor: string | null = null;

  getOverrideBarColor(): string | null {
    if (this.barColor && this.barColor !== '') {
      return this.barColor;
    } else {
      return null;
    }
  }
}
